<template>
    <div class="loader-outer rounded ">
        <div class="message">
            <h1>{{message.header}}</h1>
            <span v-html="message.body"/>
        </div>

    </div>
</template>
<script>
export default {
    props: {
        message: {
            type: Object,
            required: false,
            default () {
                return {
                    header: 'Updating...',
                    body: 'wont be long :)',
                };
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.loader-outer{
    position: absolute;
    top:0;
    bottom: 0;
    left:0;
    right:0;
    z-index:10;
    background:var(--primaryColour);
    color: var(--textOnPrimary);
    .message{
        text-align: center;
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%);
        h1{
            font-size: 28px;
        }
    }
}
</style>
